import API from "../config/api.js";

export default function BlueprintCard({ blueprint }) {
  const getImageUrl = (path) => {
    if (!path) return "/assets/img/624x427.png";
    return `${API.baseUrl}/${path.replace("original.jpg", "624x427.jpg")}`;
  };

  const getFileUrl = (path) => {
    if (!path) return "#";
    if (path.startsWith("http://") || path.startsWith("https://")) return path;
    return `${API.baseUrl}/${path}`;
  };

  const imageSrc = getImageUrl(blueprint.image);
  const fileUrl = getFileUrl(blueprint.file);

  const isNew =
    blueprint.date &&
    new Date(blueprint.date) > new Date(Date.now() - 20 * 24 * 60 * 60 * 1000);

  const categories = Array.isArray(blueprint.categories)
    ? blueprint.categories
    : [];

  return (
    <div className="card h-100 rounded-4 animate__animated animate__fadeIn animate__slow">
      <div className="p-2">
        <div className="position-relative">
          <img
            src={imageSrc}
            alt={blueprint.title || ""}
            className="bg-loading img-fluid w-100 rounded-3"
            width="624"
            height="427"
            loading="lazy"
            onError={(e) => {
              e.currentTarget.src = "/assets/img/624x427.png";
            }}
          />

          {isNew && (
            <div className="position-absolute top-0 end-0">
              <div className="bg-secondary-light text-dark rounded shadow-sm py-2 text-center m-3 px-3 small new-tag">
                NEW
              </div>
            </div>
          )}
        </div>
      </div>

      <div className="card-header bg-white rounded border-bottom-0">
        <div className="mb-2 categories">
          {categories.map((category, index) => (
            <span
              key={category.idcategory || `${category.title}-${index}`}
              className="link-primary fw-bold me-2 mb-2"
            >
              {category.title}
            </span>
          ))}
        </div>

        <h2 className="mt-2 text-capitalize fs-6 fw-bold">{blueprint.title}</h2>
      </div>

      <div className="card-body pt-0">
        <p>{blueprint.content}</p>

        {Number(blueprint.totalpages) > 0 && (
          <p className="text-muted small mb-0">
            {blueprint.totalpages} pages
          </p>
        )}
      </div>

      <div className="card-footer border-top-0 bg-transparent pb-3">
        <a
          href={fileUrl}
          className="btn btn-secondary w-100"
          target="_blank"
          rel="noreferrer"
        >
          Download
        </a>
      </div>
    </div>
  );
}